import { GET_WORKERS_HASHRATE_STATS } from '../actions/types';

export default (state = null, action) => {
  switch (action.type) {
    case GET_WORKERS_HASHRATE_STATS:
      return action.payload;
    default:
      return state;
  }
};
